import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Contributor from "./components/Contributor";
// require('dotenv').config();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route Component={App} path="/" />
      <Route Component={Contributor} path="/:contributor" />
    </Routes>
  </BrowserRouter>
);
